// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"21":"change-password","563":"content","571":"settings","858":"custom-urls","929":"distributions"}[chunkId] || chunkId) + "-legacy." + {"21":"0e446df0","45":"aac0935f","563":"5d0a1ffc","571":"88b0af55","858":"0ee96571","929":"09c4a642"}[chunkId] + ".js";
};